export default [
  {
    name: 'root',
    label: 'Wrapper',
    selector: '&',
  },
  {
    name: 'title',
    label: 'Title',
    selector: '& .title',
  },
  {
    name: 'bar',
    label: 'Bar',
    selector: '& .bar',
  },
  {
    name: 'bar_inner',
    label: 'Bar Inner',
    selector: '& .bar-inner',
  },
];
